<form novalidate>
  <div class="row flex-row align-items-end">
    @if (canFilterByClients) {
      <div class="col">
        <div class="my-0 py-0">
          <label for="clientIds"><strong>Clients</strong></label>
          <app-client-select
            name="clientIds"
            placeholder="Filter by Client"
            [multiple]="true"
            [autoLoad]="true"
            [listFilters]="{ applicableToReferralClaims: true }"
            [(selectedIds)]="filters.selectedClientIds"
            (changed)="onFilterChange()"
          />
        </div>
      </div>
    }
    <div class="col">
      <div class="my-0 py-0">
        <label for="patientFirstName"><strong>Patient First Name</strong></label>
        <input
          id="patientFirstName"
          class="form-control"
          name="patientFirstName"
          placeholder="Filter By First Name"
          [(ngModel)]="filters.patientFirstName"
          (input)="onTextFilterChange()">
      </div>
    </div>
    <div class="col">
      <div class="my-0 py-0">
        <label for="patientLastName"><strong>Patient Last Name</strong></label>
        <input
          id="patientLastName"
          class="form-control"
          name="patientLastName"
          placeholder="Filter By Last Name"
          [(ngModel)]="filters.patientLastName"
          (input)="onTextFilterChange()">
      </div>
    </div>
    <div class="col">
      <div class="my-0 py-0">
        <label for="patientDob"><strong>Patient DOB</strong></label>
        <input
          id="patientDob"
          class="form-control"
          type="date"
          name="patientDob"
          [(ngModel)]="filters.patientDob"
          (change)="onFilterChange()"
          >
      </div>
    </div>
    <div class="col">
      <button class="btn btn-info clear-button" (click)="onClearClick()">Clear All</button>
    </div>
  </div>
</form>
@if (showTable) {
  <div class="mt-2">
    <table class="table table-bordered table-hover">
      <thead class="table-dark">
        <tr>
          <th>PATIENT</th>
          @if (canFilterByClients) {
            <th>CLIENT</th>
          }
          <th>DOB</th>
          <th>MRN</th>
          <th>DOCUMENT</th>
          <th></th>
          <th class="text-center">UPLOADED TO EHR</th>
          <th>COMPLETED BY</th>
        </tr>
      </thead>
      <tbody>
        @for (patientAttachment of patientAttachments; track patientAttachment) {
          <tr>
            <td>{{ patientAttachment.patient.fullName }}</td>
            @if (canFilterByClients) {
              <td>{{ patientAttachment.client.name }}</td>
            }
            <td>{{ patientAttachment.patient.dob | date: 'MM/dd/yyyy' }}</td>
            <td>{{ patientAttachment.patient.mrn }}</td>
            <td>{{ patientAttachment.fileName | blankValueDash }}</td>
            <td>
              @if (patientAttachment.fileName) {
                <a href="/download" (click)="download($event, patientAttachment)">
                  Download
                </a>
              }
              @if (patientAttachment.pdfGenerationPending) {
                <span>
                  Preparing
                </span>
              }
            </td>
            <td class="text-center">
              <mat-slide-toggle
                [disabled]="disableEhrToggle(patientAttachment.id)"
                [checked]="!!patientAttachment.ehrUploadAt"
                (change)="onUploadToggle($event, patientAttachment)"
                color="primary"
                >
                {{ !!patientAttachment.ehrUploadAt ? 'Yes' : 'No' }}
              </mat-slide-toggle>
            </td>
            <td>
              @if (!!patientAttachment.ehrUploadAt) {
                <div>
                  <strong>{{ patientAttachment.ehrUploadBy }}</strong> on
                  {{ patientAttachment.ehrUploadAt | date: 'MM/dd/yyyy' }}
                </div>
              }
            </td>
          </tr>
        }
      </tbody>
    </table>
    <app-pagination [paging]="paging" (pageChange)="onPageChange($event)" />
  </div>
}

@if (noResults) {
  <div class="mt-2 ms-1">There are no consult notes.</div>
}

@if (loading) {
  <div class="mt-2 ms-1"><mat-spinner diameter="30" /></div>
}
